module.exports = __webpack_public_path__ + "static/media/0661f50d.jpg";